import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from 'src/constants/other';
import { RootState } from 'src/store';
import { fetchWithRetry } from 'src/utils/fetch-retry';
import { clientSession } from 'src/utils/session-storage';

import { matchesQuizVersion, STALE_QUIZ_REQUEST, VERSION_MISMATCH } from './match-quiz-version';

export const getStatements = createAsyncThunk(
  'data/getStatements',
  async (_, { getState, rejectWithValue }) => {
    const sessionId = clientSession.get()?.sessionId;
    const partiesVersionId = (getState() as RootState).data.main?.versionId;
    const data = await fetchWithRetry(`${API_URL}/public/statements.json`);

    if (!sessionId || clientSession.get()?.sessionId !== sessionId) {
      return rejectWithValue(STALE_QUIZ_REQUEST);
    }

    if (!matchesQuizVersion(data?.versionId, partiesVersionId)) {
      clientSession.remove();
      return rejectWithValue(VERSION_MISMATCH);
    }

    return data;
  },
  {
    condition: (_, { getState }) => {
      const { loadingStatements, statements } = (getState() as RootState).data;

      if (loadingStatements || statements) {
        return false;
      }

      return Boolean(clientSession.get()?.version);
    },
  }
);
